import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const MovementPageNameFieldsHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: flex;
    gap: 24px;
  }
`;
